export default function MaintenanceService($http, appSettings, MaintenanceMockService, $uibModal) {
  'ngInject';
  if (appSettings.FixturesModeEnabled) {
    return MaintenanceMockService;
  }

  this.showPopupForEquipmentPlan = function(equipment, plan) {
    let modalInstance = $uibModal.open({
      animation: true,
      template: require('../pages/maintenance/board/complete/complete.html'),
      controller: 'MaintenancePerformPopupController',
      size: 'md',
      windowClass: 'tr-maintenance-modal-dismiss',
      resolve: {
        equipmentData: equipment,
        plan: plan
      }
    });
    return modalInstance;
  };

  const baseURL = `${appSettings.InReachApiEndpoint}/maintenance`;

  this.getPlans = function() {
    const endpoint = `${baseURL}/plans`;
    return $http.get(endpoint);
  };

  this.getPlan = function(planId) {
    const endpoint = `${baseURL}/plans/${planId}`;
    return $http.get(endpoint);
  };

  this.updatePlan = function(plan) {
    if (!plan) return;
    const endpoint = `${baseURL}/plans/${plan.id}`;
    return $http.put(endpoint, plan);
  };

  this.getEquipmentForPlan = function(plan) {
    if (!plan) return;

    if (!plan.id) {
      plan = {
        id: plan
      };
    }

    const endpoint = `${baseURL}/plans/${plan.id}/equipment`;
    return $http.get(endpoint);
  };

  this.updateEquipmentForPlan = function(plan, equipmentChangeSet) {
    if (!plan) return;

    if (!plan.id) {
      plan = {
        id: plan
      };
    }

    const endpoint = `${baseURL}/plans/${plan.id}/equipment`;
    return $http.patch(endpoint, equipmentChangeSet);
  };

  this.createPlan = function(plan) {
    if (!plan) return;

    let endpoint = `${baseURL}/plans`;
    return $http.post(endpoint, plan);
  };

  this.deletePlan = function(plan) {
    if (!plan) return;

    if (!plan.id) {
      plan = {
        id: plan
      };
    }

    const endpoint = `${baseURL}/plans/${plan.id}`;
    return $http.delete(endpoint);
  };

  this.getPlanTasks = function(plan) {
    if (!plan) return;

    if (!plan.id) {
      plan = {
        id: plan
      };
    }

    const endpoint = `${baseURL}/plans/${plan.id}/tasks`;
    return $http.get(endpoint);
  };

  this.getTaskInPlan = function(plan, taskId) {
    if (!plan || !taskId) return;

    if (!plan.id) {
      plan = {
        id: plan
      };
    }

    const endpoint = `${baseURL}/plans/${plan.id}/tasks/${taskId}`;
    return $http.get(endpoint);
  };

  this.createTaskInPlan = function(plan, task) {
    if (!plan || !task) return;

    if (!plan.id) {
      plan = {
        id: plan
      };
    }

    const endpoint = `${baseURL}/plans/${plan.id}/tasks`;
    return $http.post(endpoint, task);
  };

  this.updateTaskInPlan = function(plan, task) {
    if (!plan || !task) return;

    if (!plan.id) {
      plan = {
        id: plan
      };
    }

    let taskId = task.id;

    const endpoint = `${baseURL}/plans/${plan.id}/tasks/${taskId}`;
    return $http.put(endpoint, task);
  };

  this.deleteTaskInPlan = function(plan, taskId) {
    if (!plan || !taskId) return;

    if (!plan.id) {
      plan = {
        id: plan
      };
    }

    if (taskId.id) {
      taskId = taskId.id;
    }

    const endpoint = `${baseURL}/plans/${plan.id}/tasks/${taskId}`;
    return $http.delete(endpoint);
  };

  //Get the maintenance status for this account...to display on the dashboard
  this.getStatus = function(query, equipIds, code) {
    let endpoint = `${baseURL}/status`;

    if (query) {
      endpoint += `?q=${query}`;
    } else {
      endpoint += '?q=*';
    }

    if (equipIds) {
      endpoint += '&queryequipmentids=';

      for (let i = 0; i < equipIds.length; i++) {
        if (i === equipIds.length - 1) {
          endpoint += equipIds[i];
        } else {
          endpoint += equipIds[i] + ',';
        }
      }
    }

    if (code) {
      endpoint += `&code=${code}`;
    }

    return $http.get(endpoint);
  };

  //Get the maintenance status for this account...to display on the dashboard
  this.getHistory = function(query, equipIds) {
    let endpoint = `${baseURL}/service-records`;

    if (query) {
      endpoint += `?q=${query}`;
    } else {
      endpoint += '?q=*';
    }

    if (equipIds) {
      endpoint += '&queryequipmentids=';

      for (let i = 0; i < equipIds.length; i++) {
        if (i === equipIds.length - 1) {
          endpoint += equipIds[i];
        } else {
          endpoint += equipIds[i] + ',';
        }
      }
    }

    return $http.get(endpoint);
  };

  this.getServiceRecord = function(recordId) {
    if (!recordId) {
      return null;
    }

    const endpoint = `${baseURL}/service-records/${recordId}`;
    return $http.get(endpoint);
  };

  this.getServiceRecordTasks = function(recordId) {
    if (!recordId) {
      return null;
    }

    const endpoint = `${baseURL}/service-records/${recordId}/tasks`;
    return $http.get(endpoint);
  };

  this.newServiceRecord = function(record) {
    if (!record) {
      return null;
    }

    const endpoint = `${baseURL}/service-records`;
    return $http.post(endpoint, record);
  };

  this.completeTasks = function(recordId, tasks) {
    if (!recordId || !tasks) {
      return null;
    }

    const endpoint = `${baseURL}/service-records/${recordId}/tasks`;
    return $http.patch(endpoint, {
      op: 'complete',
      values: tasks
    });
  };

  this.getDashboardAggregate = function() {
    const endpoint = `${baseURL}/aggregate`;
    return $http.get(endpoint);
  };

  this.getFacetHits = function() {
    const endpoint = `${appSettings.IcebergApiEquipmentEndpoint}/equipment/search?q=*&facet.tags={buckets:[]}`;
    return $http.get(endpoint);
  };

  this.getPlanCsvData = function() {
    const endpoint = `${baseURL}/csvexport`;
    return $http({
      method: 'GET',
      cache: false,
      url: endpoint,
      responseType: 'arraybuffer'
    });
  };
}
